module.exports = __webpack_public_path__ + "static/den1-ffaabf009413793461aacfa63677ba44.jpg";